<template>
    <layout>        

        <template v-slot:username>
            <v-form 
                class="pa-5"
                @submit.prevent
            >
                <v-text-field
                    label="Username"
                    placeholder="Enter username"
                    name="id"                                                
                    type="text"
                    color="primary"
                    v-model="formData.name"
                    clearable
                    autofocus
                    v-on:keyup="keyPress"
                    auto-complete="off"
                >
                    <v-icon
                        slot="prepend"
                        color="primary"
                    >
                        mdi-account
                    </v-icon>
                </v-text-field>
                <div class="text-right mt-4 mb-4">                                                
                    <v-btn 
                        color="primary"
                        @click="nextStep" 
                        dark
                        block
                    >NEXT</v-btn>
                </div>
            </v-form>
        </template>

        <template v-slot:password>
            <v-form 
                class="pa-5"
                @submit.prevent="submit"
            >
                <v-text-field
                    v-show="password"
                    :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                    :type="show ? 'text' : 'password'"
                    :label="passwordLabel"
                    :placeholder="passwordPlaceholder"
                    :hint="passwordHint"
                    persistent-hint
                    @click:append="show = !show"                                                    
                    name="password"
                    v-model="formData.password"
                    clearable
                    autofocus
                    color="primary"
                >
                    <v-icon
                        slot="prepend"
                        color="primary"
                    >
                        mdi-key
                    </v-icon>
                </v-text-field>
            

                <div class="text-right mt-4  mb-4">
                    <v-btn 
                        color="primary"
                        @click="submit" 
                        dark
                        block
                     >
                        LOGIN
                     </v-btn>
                </div>
            </v-form>             
        </template>

    </layout>
</template>

<script>
import Layout from '../layouts/Login';
import { mapGetters, mapActions, mapMutations } from 'vuex';
export default {
    name: 'LoginTermReports',
    components: {
        Layout
    },
    data: () => ({
        formData: {
            name: '',
            password: '',            
        },
        show: false,        
        passwordPlaceholder: 'Enter password',
        passwordLabel: 'Password',
        passwordHint: '',
        password: true,
    }),
    computed: {
        ...mapGetters({            
            primaryColor: 'app/getPrimaryColor',
            colorDarken: 'app/getColorDarken',            
            step: 'auth/getStep',
            authenticated: 'auth/getAuthenticated',
            resetPassword: 'auth/getResetPassword',                       
        }),        
        icon_color(){
             return this.primaryColor+' '+this.colorDarken;
        },
        title_css(){
            return  this.primaryColor+'--text text--'+this.colorDarken+' text-h5 text-left ';
        },
        themeColor(){
            return this.primaryColor + ' ' +this.colorDarken;
        }
    },
    methods: {
        ...mapActions({
            signIn: 'auth/signIn', 
            employee: 'auth/employee',
            getUser: 'auth/user',
            getUserPermissionList: 'app/getUserPermissionList',
            setAuthenticated: 'auth/setAuthenticated',
            userPermissions: 'auth/userPermissions',
            serverError: 'auth/serverError',          
        }),

        ...mapMutations({
            loginError: 'auth/setLoginErrors', 
            setStep: 'auth/setStep',
            setOverlay: 'auth/setOverlay',
            setUserName: 'auth/setUserName',
            setResetPassword: 'auth/setResetPassword',
            setPermissions: 'auth/setPermissions',
            setEmployeeId: 'auth/setEmployeeId',
            setCredentials: 'auth/setCredentials',
            setAuthenticated: 'auth/setAuthenticated',
            setEmployeeSignedIn: 'auth/setEmployeeSignedIn',
            setEmployeeInitials: 'auth/setEmployeeInitials'           
        }),

        async nextStep () {
            this.setOverlay(true);
            //console.log('next step');            
            this.setUserName(this.formData.name);
            try {
                let user = await this.getUser();               
                this.setEmployeeId(user.data.employee_id);
                sessionStorage.setItem('employeeSignedIn', user.data.first_name + ' ' + user.data.last_name);
                sessionStorage.setItem('employeeInitials', user.data.first_name[0] + user.data.last_name[0]) 
                this.setEmployeeSignedIn(user.data.first_name + ' ' + user.data.last_name);
                this.setEmployeeInitials(user.data.first_name[0] + user.data.last_name[0]);
                this.setOverlay(false);
                this.loginError('');
                
                if(user.data.password_reset == 1){
                    this.setResetPassword(true);
                }
                else{
                    this.setResetPassword(false);                    
                }
                this.setStep(2); 

            } catch (error) {
                this.setOverlay(false);
                //console.log(error);
                //console.log(error.response);
                if(error.response){
                    this.loginError(error.response.data);
                }
                else{
                    this.loginError(`An Error has occured ( ${error})`)
                }
                
            }
            
            
        },

        async submit () {
            let response = null;               
            console.log('Authenticating...');
            this.setOverlay(true);
            this.setCredentials(this.formData);
           
            try {
                const authPromise = this.signIn();
                const permissionsPromise = this.userPermissions(); 
                response = await authPromise;
                sessionStorage.authenticated = response.data;
                sessionStorage.employeeId = response.data[0].employee_id;
                console.log('Authenticated.')                
                this.setAuthenticated(true);
                this.loginError('');                
                
                const permissions = await permissionsPromise;
                sessionStorage.setItem('permissions', JSON.stringify(permissions.data));
                // this.setPermissions(permissions.data);
                //console.log(permissions.data);
                
                if(this.resetPassword == 1){
                    this.setStep(3);                    
                }
                else{
                    this.$router.replace('/app');
                }                                
                              
            } catch (error) {
                console.log(error.response);
                this.serverError(error);
                
            }
            this.setOverlay(false);
        },
        
        keyPress (e) {
            if(e.keyCode === 13){
                this.nextStep();
            }
        },
        
    },
}
</script>